export default {
  userContext: state => state.userContext,
  forms: state => state.forms,
  completed: state => state.completed,
  currentForm: state => state.currentForm
}
